import { push } from "connected-react-router";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH,APPLICATION_MODE_NEW } from "../../../app/constants";
import { Button, ErrorWithString } from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { replaceUrlParams } from "../../../app/utils";

export const AgeConfirmationView = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  const [showConfirmationError, setShowConfirmationError] = useState(false);

  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const licencingSubType = agencyApplication?.licencingSubType;
  
  const handleNext = (isResidentOfCanada) => () => {
    setShowConfirmationError(!isResidentOfCanada);
    
    if(isResidentOfCanada) {
      const nextPath = replaceUrlParams(ROUTE_PATH.NS_LOGIN,application,APPLICATION_MODE_NEW)
        dispatch(push(nextPath));
    }
  };

  return (
    <div className="container">
      <TopNavigationBar 
          {...props} 
          applicationType={applicationTypeFromLicenceSubType(licencingSubType)} 
          applicationMode={APPLICATION_MODE_NEW} 
      />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>Are you at least 19 years old?</h1>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div className="col-lg-2 ">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(true)}
            text={"Yes"}
          />
        </div>

        <div className="col-lg-3 has-error">
          <Button
            className={"ns-btn-yes-no btn-default"}
            buttonType="primary_regular"
            onClick={handleNext(false)}
            value={false}
            text={"No"}
          />
          {showConfirmationError &&
            ErrorWithString(`The ${isPrincipalBroker ? 'Principal Broker' : 'Compliance Officer'} must be at least 19 years old.`)
          }
        </div>
      </div>
    </div>
  );
};
